import { ILatestNewsModel } from "../../../common/models/latestnews/ILatestNewsModel";
import { IBuildingRankUpModel } from "./IBuildingRankUpModel";

export class BuildingRankUpFromNewsModel implements IBuildingRankUpModel {
    public readonly additionalVisitRewardPercentage: number;
    public readonly totalRewardInCoins: number;
    public readonly landlordRewardInCoins: number;
    public readonly currentGuestRewardInCoins: number;
    public readonly additionalPiggyBankTokensMultiplierPercentage: number;
    public readonly level: number;
    public readonly fromUpgrade: boolean;

    public constructor(latestNewsModel: ILatestNewsModel, coinsAmount: number, buildingLevel: number) {
        this.additionalVisitRewardPercentage = 0;
        this.totalRewardInCoins = coinsAmount + (latestNewsModel.latestNewsInfo.value.landlord?.rewardInCoins ?? 0);
        this.landlordRewardInCoins = latestNewsModel.latestNewsInfo.value.landlord?.rewardInCoins ?? 0;
        this.currentGuestRewardInCoins = coinsAmount;
        this.additionalPiggyBankTokensMultiplierPercentage = latestNewsModel.latestNewsInfo.value.additionalPiggyBankTokensMultiplierPercentage;
        this.level = buildingLevel;
        this.fromUpgrade = false;
    }
}
